import AnyCookieConsent from "@anything-studio/any-cookie-consent"

AnyCookieConsent.init();